import { components } from "@certn/api/generated-schemas/client-portal";
import { StatusTag } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface CredentialRequestStatusProps {
  credentialRequest: {
    status: components["schemas"]["CredentialRequestStatus"];
    defer_availability: boolean;
  };
}

export function CredentialRequestStatus({
  credentialRequest: { status, defer_availability },
}: CredentialRequestStatusProps) {
  const { t } = useTranslation();

  const statusMap = {
    CREATED: t("Pending"),
    INVITED: t("Pending"),
    REQUEST_DENIED: t("Request denied"),
    WITHDRAWAL_REQUESTED: t("Withdrawal requested"),
    WITHDRAWN: t("Withdrawn"),
    CANCELLED: t("Cancelled"),
  };

  const label =
    status === "CREDENTIALS_AVAILABLE"
      ? defer_availability
        ? t("Locked")
        : t("Credentials available")
      : statusMap[status];

  return <StatusTag statusInfoIcon={false}>{label}</StatusTag>;
}
